import { HumanizeDatePipe } from './humanize-date.pipe';
import { NgModule } from "@angular/core";

import { FilterPipe } from "./filter.pipe";
import { KeysPipe } from "./keys.pipe";
import { SearchPipe } from "./search.pipe";
import { HumanizeCamelCasePipe } from './humanize-camel-case.pipe';
import { HtmlSanitizerPipe } from './html-sanitizer.pipe';
import { TextCapitalizePipe } from './text-capitalize.pipe';
@NgModule({
  declarations: [FilterPipe, KeysPipe, SearchPipe, HumanizeCamelCasePipe, HumanizeDatePipe, HtmlSanitizerPipe, TextCapitalizePipe],
  imports: [],
  exports: [FilterPipe, KeysPipe, SearchPipe, HumanizeCamelCasePipe, HumanizeDatePipe, HtmlSanitizerPipe,TextCapitalizePipe],
})
export class PipesModule {}
